// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"305":"2d50a230","540":"70fc79e2","603":"6bb01b90","781":"95e76983"}[chunkId] + ".chunk.css";
};